/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";

export const getUi = (state) => state.ui;
export const getActiveHeader = createSelector([getUi], (ui) =>
  ui && ui.activeHeader ? ui.activeHeader : null,
);
export const getPortalErrorStatus = createSelector([getUi], (ui) =>
  ui && ui.showPortalError ? ui.showPortalError : null,
);
export const getDpFilter = createSelector([getUi], (ui) =>
  ui && ui.dpfilter ? ui.dpfilter : null,
);
export const getActiveView = createSelector([getUi], (ui) =>
  ui && ui.activeView ? ui.activeView : null,
);
export const getActiveViewCon = createSelector([getUi], (ui) =>
  ui && ui.activeViewCon ? ui.activeViewCon : null,
);
export const getValidationStatus = createSelector([getUi], (ui) =>
  ui && ui.validateResponse ? ui.validateResponse : null,
);
